import styled from 'styled-components'
import { IThemeProps } from '../../../models/interfaces'
import { Text } from './Text'

export const SidebarCardText = styled(Text)`
  color: ${(props: IThemeProps) => props.theme?.colors?.font?.secondary || ''};
`
